// Libraries
import React from "react";

// Styles
import { SvgIconContainer } from "./styled";
import {ReactSVG} from "react-svg";

function SvgIcon({
  icon = { url: "" },
  color,
  size = "24px",
  onClick = () => ({}),
}) {
  return (
    <SvgIconContainer color={color} size={size} onClick={() => onClick()}>
      <ReactSVG src={icon.url} />
    </SvgIconContainer>
  );
}

export default SvgIcon;
